import { useState } from "react";

export const Bone = ({ w="100%", h=14, r=8, style={} }) => (
  <span className="bone" style={{ width:w, height:h, borderRadius:r, display:"block", ...style }} />
);

export const Avatar = ({ name, large }) => {
  const i = name.split(" ").map(
    w => w[0]
  ).join("").toUpperCase().slice(0,2);

  return <div
          className = {`avatar ${large ? "avatar-lg" : "" }` }> {i}
        </div>;
};

export const StatusBadge = ({ paid }) => (
  <span className={`badge ${
        paid
        ? "badge-success"
        : "badge-danger"
      }`
    }>
    {paid ? "Lunas" : "Belum Bayar" }
  </span>
);

export const CopyBtn = ({ value }) => {
  const [coppied, setCoppied] = useState(false);
  const click = () => {
        navigator.clipboard.writeText(value);
        setCoppied(true);
        setTimeout(() => setCoppied(false), 1600);
    };

  return (
    <button
        className="btn-icon"
        onClick={click}
        title="Salin"
        style={{ marginLeft:6 }}
    >
      {
        coppied
        ? <i className="fa fa-check"/>
        : <i className="fa fa-copy"/>
      }
    </button>
  );
};

export const TopLoader = ({ on }) => (
  <div className="top-loader">
    <div className="top-loader-fill" style={{ opacity: on ? 1 : 0 }} />
  </div>
);

export const DarkToggle = ({ dark, toggle }) => (
  <button className={`dark-toggle ${dark ? "on" : ""}`}
    onClick={toggle} title="Toggle dark mode">
      <div className="dark-toggle-thumb">
        {dark ? "Dark" : "Light"}
      </div>
  </button>
);
